import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const openQualifyChat = () => {
    setIsMobileMenuOpen(false);
    window.dispatchEvent(new CustomEvent('open-qualify-chat'));
  };

  return (
    <header className={`dark-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <div className="dark-logo" onClick={scrollToTop} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          <img 
            src="/mpv-logo.png" 
            alt="MPV Solutions Logo" 
            style={{ 
              height: '48px', 
              width: 'auto',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.filter = 'drop-shadow(0 0 15px rgba(0, 255, 209, 0.8))';
              e.target.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.target.style.filter = 'none';
              e.target.style.transform = 'scale(1)';
            }}
          />
        </div>

        <nav className="dark-nav desktop-nav">
          <button onClick={() => scrollToSection('masterclass')} className="dark-nav-link">
            LÖSUNGEN
          </button>
          <button onClick={() => scrollToSection('concept')} className="dark-nav-link">
            UNSER KONZEPT
          </button>
          <button onClick={() => scrollToSection('results')} className="dark-nav-link">
            ERFOLGE
          </button>
          <a 
            href="/ki-academy" 
            className="academy-nav-link"
          >
            MASTERCLASS ACADEMY
          </a>
          <button onClick={openQualifyChat} className="btn-primary" data-testid="header-kontakt-btn">
            KONTAKT
          </button>
        </nav>

        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="mobile-menu open">
          <button onClick={() => scrollToSection('masterclass')} className="mobile-nav-link">
            LÖSUNGEN
          </button>
          <button onClick={() => scrollToSection('concept')} className="mobile-nav-link">
            UNSER KONZEPT
          </button>
          <button onClick={() => scrollToSection('results')} className="mobile-nav-link">
            ERFOLGE
          </button>
          <a 
            href="/ki-academy" 
            className="academy-nav-link"
            style={{ display: 'block', width: '100%', textAlign: 'center' }}
          >
            MPV ACADEMY
          </a>
          <button onClick={openQualifyChat} className="btn-primary mobile-cta" data-testid="mobile-kontakt-btn">
            KONTAKT
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
